import{pathBuilder}from'config/paths/index';export var root='/admin/roles-v2';export default pathBuilder(root);